define('modules/editor/models/property_groups/form_label',['require','exports','module','./base','lib/util'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "form:label",
    properties: ["fontWeight", "fontFamily", "fontSize", "color", "align"],
    generateStyles: function($el, id){
      return [
        {
          selector: "#" + id + " label.control-label",
          rules: {
            "font-family": this.get("fontFamily"),
            "font-weight": this.get("fontWeight"),
            "font-size": this.get("fontSize") + "px",
            "color": this.get("color")
          }
        }
      ];
    },
    applyStyles: function($el){
      var theForm = $el.find("form");
      //align
      var align = this.get("align");
      theForm.toggleClass("form-horizontal", align === "left");
      theForm.toggleClass("form-vertical", align === "top");
    },
    validators: {
      "fontSize": function(attrs){
        var value = parseInt(attrs.fontSize);
        return this.isInteger(attrs.fontSize) && this.isNumber(value) && this.isInRange(value, 10, 60);
      }
    }
  });
});

